import { ThemeConfig } from 'antd';
// https://ant.design/docs/react/customize-theme
export const classic: ThemeConfig = {
  token: {
    colorPrimary: '#53D2D7', 
    colorPrimaryBgHover:'#22A9CF',
    colorFillSecondary: '#EA7A49',
    colorBorderSecondary: "EF6226",
    colorText: '#113969',
    colorTextSecondary: '#11396999',
    colorFillAlter: '#f0f0f0',
    colorIcon: '#0B446F', //'#188',
    colorIconHover: '#0B446F', //'#188',
    colorLink: '#0B446F', // '#188',
    colorError: '#CC3E58 ',
    colorSuccess:'#2DBF70',
    colorWhite: '#fff',
  },
  components: {
    Input: {
      colorText: '#113969',
      colorTextPlaceholder: '#11396999',
    },
    Modal: {
      colorText: '#4A4A4A',
    },
    Drawer: {
      colorText: '#000000',
    },
    Table: {
      colorText: '#000000',
    },
  },
};
